var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelopIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 102,
  fill: "none",
  viewBox: "0 0 101 102",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 67.333,
  height: 50.5,
  x: 16.833,
  y: 25.75,
  stroke: "#51A196",
  strokeWidth: 5.05,
  rx: 8.417
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#51A196",
  strokeWidth: 5.05,
  d: "m16.833 38.375 29.903 14.951a8.42 8.42 0 0 0 7.528 0l29.903-14.951"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#51A196",
  strokeWidth: 4,
  d: "M47.63 51.538 22.041 38.743a5.803 5.803 0 0 1 2.595-10.993h51.728a5.803 5.803 0 0 1 2.595 10.993l-25.59 12.795a6.42 6.42 0 0 1-5.739 0Z"
})));
export { SvgEnvelopIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/Envelop_Icon.svg";